export interface ISiteRole {
  siteId: string;
  siteRole: string;
}

// More info here: http://mytableau/display/devft/Site+Role
// And at: http://mytableau/display/devft/getSiteUsers
export let SiteRoles = {
  ServerAdministrator:       'ServerAdministrator',
  SiteAdministratorCreator:  'SiteAdministratorCreator',
  SiteAdministratorExplorer: 'SiteAdministratorExplorer',
  SupportUser:               'SupportUser',
  Creator:                   'Creator',
  ExplorerCanPublish:        'ExplorerCanPublish',
  Explorer:                  'Explorer',
  Viewer:                    'Viewer',
  Unlicensed:                'Unlicensed',
  ViewerWithPublish:         'ViewerWithPublish',
  UnlicensedWithPublish:     'UnlicensedWithPublish',
  Guest:                     'Guest'
};
